import script from "./ds-radio.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20DsFormFieldValueType"
export * from "./ds-radio.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20DsFormFieldValueType"

const __exports__ = script;

export default __exports__